<template>
  <div class="tab-pane fade" id="estimate-people" role="tabpanel" aria-labelledby="estimate-people-tab">
    <div class="container-fluid">
      <form class="row g-3">
        <div class="col-md-3">
          <label for="inputEmail4" class="form-label">風景區</label>
          <select class="form-select form-select" v-model.number="selectScenicAreaId">
            <option value="-1">全部</option>
            <option v-for="(list, index) in carFlowScenicArea" :key="index" :value="list.id">{{ list.name }}</option>
          </select>
        </div>

        <div class="col-md-4">
          <label for="inputPassword4" class="form-label">資料開始時間</label>
          <datetime input-class="form-control" type="datetime" format="yyyy-MM-dd HH:mm"
            :phrases="{ ok: '確認', cancel: '取消' }" :minute-step="1" :max-datetime="maxSelectTime" :auto="true"
            v-model="startTime" @focus="updateMaxSelectTime">
          </datetime>
        </div>

        <div class="col-md-4">
          <label for="inputPassword4" class="form-label">資料結束時間</label>
          <datetime input-class="form-control" type="datetime" format="yyyy-MM-dd HH:mm"
            :phrases="{ ok: '確認', cancel: '取消' }" :minute-step="1" :max-datetime="maxSelectTime" :auto="true"
            v-model="endTime" @focus="updateMaxSelectTime">
          </datetime>
        </div>

        <div class="col-md-6 d-flex align-items-end">
          <button type="button" class="btn btn-success bg-cyan btn-sm rounded-pill px-3 mx-1" @click="queryElk()" :disabled="isWaitCCTVList">
            <i class="fas fa-search"></i> 查詢
          </button>
          <button type="button" class="btn btn-primary btn-sm rounded-pill px-3 mx-1" @click="exportCSV()" :disabled="isWaitCCTVList"> 
            <i class="fas fa-share"></i> 匯出
          </button>
        </div>
      </form>

      <h1 style="margin-top: 0px;">即時_車流推估人流</h1>
      <p class="mb-0">備註 1 ：若車流負值所計算出的分時預估人流若為負值，則會以 0 顯示。</p>
      <p>備註 2 ：統計欄位的預估人流為各時段預估人流（含負值）總和且四捨五入至整數位。</p>


      <div class="row row-cols-1 row-cols-md-1 row-cols-lg-1 row-cols-flex g-2">
        <div class="col">
          <div class="card card-clean h-100">
            <div class="bd-example">

              <table id="estimatePeopleFlow" class=" w3-table-all table table-hover table-striped">
                <thead class="table-dark ">
                  <tr>
                    <th scope="col" width="5%">#</th>
                    <th scope="col">時間</th>
                    <th scope="col">景區</th>
                    <th scope="col">機車</th>
                    <th scope="col">小型車</th>
                    <th scope="col">大型車</th>                    
                    <th scope="col">小巴</th>
                    <th scope="col">卡車</th>
                    <th scope="col">預估人流</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in estimatePeopleList" :key="index" :class="tableCenterStyle">
                    <td>{{ index + 1 }}</td>
                    <td style="white-space: pre-line;">{{ item.time }}</td>  <!-- style讓 \n可以換行-->
                    <td>{{ item.areaName }}</td>
                    <td>{{ item.motorbike }}</td>
                    <td>{{ item.car }}</td>
                    <td>{{ item.bus }}</td>
                    <td>{{ item.smallbus }}</td>
                    <td>{{ item.truck }}</td>
                    <td>{{ removeNegativeAndDecimal(item.estimatePeopleCount)}} </td>
                    <!-- <td>{{ removeNegativeAndDecimal(item.estimatePeopleCount)}}  <span v-if="item.estimatePeopleCount<0">（{{item.estimatePeopleCount}}）</span></td> -->
                  </tr>
                </tbody>
              </table>
              
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
    

  
</template>

<script>
import moment from "moment";
import { mapState, mapGetters } from 'vuex'
import Utils from '../../utils/utils';
import CONST from '../../utils/const'
import { postVehicleInTimeIntervalPerHour } from '../../api/eastCoastDataApi/ElkQuery/VehicleElk'
import exportCSV from '../../utils/exportCSV'


export default {
  components: { },
  data() {
    return {
      Const: CONST,
      tableStyle: "table table-bordered table-hover h6",
      tableThStyle: "bg-info text-white text-center",
      tableCenterStyle: "text-center",
      table: null,
      estimatePeopleList: [],
      startTime: moment().startOf('day').format(),
      endTime: moment().startOf('minute').format(),
      selectScenicAreaId: -1,
      selectDeviceId: "-1",
      carTypeList: CONST.ELK_CAR_TYPE_ENUM,
      selectCarType: '',
      selectItem: null,
      ratioData: null,
      isWaitCCTVList: false,
      maxSelectTime:moment().startOf('m').toISOString(),
    };
  },
  computed: {
    // maxSelectTime() {
    //   return moment()
    //     .startOf('m')
    //     .toISOString()
    // },
    // ...mapState('scenicArea', { scenicAreaList: 'allscenicArea' }),
    ...mapGetters("scenicArea", {scenicAreaList: "getMyScenicArea" }),
    ...mapGetters({ ScenicAreaCCTVList: 'getScenicAreaVehicleVideoCamera' }),
    ...mapState("passengerEstimateSetting", { estimateDataList: "allEstimateData" }),
 
    carFlowScenicArea() {
      return this.scenicAreaList.filter(s => (s.additionInfo & CONST.SCENIC_AREA_ADDITION_INFO_ENUM.CAR_FLOW))
    },
  },
  watch: {
    async selectScenicAreaId() {
      // this.isWaitCCTVList = true
      // await this.$store.dispatch('scenicArea/getDeviceByScenicAreaId', { id: this.selectScenicAreaId })
      // this.selectDeviceId = "-1"
      // this.isWaitCCTVList = false
    },
  },
  methods: {

    updateMaxSelectTime() {
      this.maxSelectTime = Utils.getLastestTime();// 更新為當前時間
    },


    removeNegativeAndDecimal(value) {
      //若 value < 0 則回傳 0，若value小數則僅無條件捨去小數點後三位
      return value < 0 ? 0 : Math.floor(value*100)/100
    },

    async queryElk() {
      this.estimatePeopleList = await this.searchELK();
      this.updateTable()
    },

    async exportCSV() {
      const estimatePeopleList = await this.searchELK();

      const csvContent = [['時間', '風景區', '機車', '小型車', '大型車', '小巴', '卡車', '預估人流']]
      estimatePeopleList.forEach(item => {
        const row = []
        row.push(item.time.replace(/\n/g, ''))
        row.push(item.areaName)
        row.push(item.motorbike)
        row.push(item.car)
        row.push(item.bus)
        row.push(item.smallbus)
        row.push(item.truck)
        row.push(this.removeNegativeAndDecimal(item.estimatePeopleCount))

        csvContent.push(row)
      })

      const fileName = `即時_車流推估人流${moment(this.startTime).format('YYYY/MM/DD HH:mm')}.csv`
      exportCSV.genCSVFile(csvContent, fileName)
    },

    async searchELK() {
      if (Utils.isEmptyObject(this.startTime) || Utils.isEmptyObject(this.endTime)) {
        alert('請選擇起訖時間')
        return
      }

      const condition = {
        areas:[],
        sttime: moment(this.startTime).startOf('minute').format(),
        endtime: moment(this.endTime).startOf('minute').format(),
        interval: "hour"
      }

      if(this.selectScenicAreaId > -1) {
        condition.areas.push(this.selectScenicAreaId)
      };

      if(this.selectScenicAreaId === -1) {
        this.carFlowScenicArea.forEach(e => {
          condition.areas.push(e.id)
        });
      };

      const result = await postVehicleInTimeIntervalPerHour(condition)
      if(!result.success){
        return []
      };

      const carTypeEnumList = this.$store.getters['passengerEstimateSetting/getInternalEstimateWeight']
      const holidayMap = this.$store.getters['holidaySetting/getHolidayMap']
      const total = {
        time: '統計',
        areaName: '',
        motorbike: 0,
        car: 0,
        bus: 0,
        smallbus: 0,
        truck: 0,
        estimatePeopleCount: 0
      }

      const dataList = result.data.map(e => {
        const data ={}
        data.areaName = e.areaName
        data.time = `${moment(e.dateTime).format('YYYY-MM-DD')} \n ${moment(e.dateTime).format('HH')}~${moment(e.dateTime).add(1, 'h').format('HH')}`
        data.motorbike = e.data.motorbike
        data.car = e.data.car
        data.bus = e.data.bus
        data.smallbus = e.data.smallbus
        data.truck = e.data.truck
        data.estimatePeopleCount =  (e.totalPeopleFlow)


        // const date = moment(e.dateTime).startOf('day').format().split('+')[0]
        // const weight = holidayMap.get(date) ? 'holidayWeight' : 'weight'
        
        // Math.round(
        //  (data.motorbike * carTypeEnumList.find(e => e.enumType === CONST.CAR_TYPE.MOTO)[weight]) +
        //  (data.car * carTypeEnumList.find(e => e.enumType === CONST.CAR_TYPE.CAR)[weight]) +
        //  (data.bus * carTypeEnumList.find(e => e.enumType === CONST.CAR_TYPE.BUS)[weight]) +
        //  (data.smallbus * carTypeEnumList.find(e => e.enumType === CONST.CAR_TYPE.SMALLBUS)[weight]) +
        //  (data.truck * carTypeEnumList.find(e => e.enumType === CONST.CAR_TYPE.TRUCK)[weight])
        //    )
        total.motorbike = total.motorbike + data.motorbike
        total.car = total.car + data.car
        total.bus = total.bus + data.bus
        total.smallbus = total.smallbus + data.smallbus
        total.truck = total.truck + data.truck
        total.estimatePeopleCount = (total.estimatePeopleCount + data.estimatePeopleCount)
        
        return data
      })
      total.estimatePeopleCount = Math.round(total.estimatePeopleCount)

      dataList.push(total)
      return dataList
    },

    initTable: function () {
      this.table = $("#estimatePeopleFlow").DataTable({
        aoColumns: [
          ...new Array($("#estimatePeopleFlow th").length - 1),
          {
            bSortable: false,
          },
        ],
        language: {
          url :'/json/dataTableZHTW.json'
        },
        "pageLength": 25
      });
    },

    updateTable() {
      if (!Utils.isEmptyObject(this.table)) {
        this.table.destroy()
      }

      setTimeout(() => {
        this.initTable();
      }, 100);
    }
  },
  mounted() {
    this.updateTable()
  },
}
</script>

<style>
button:disabled {
  cursor: not-allowed;
  pointer-events: all !important;
}
tbody > tr > td {width:100%;white-space:normal;word-wrap:break-word;word-break:break-all;} /* td自動斷行 */
table{table-layout:fixed;word-break:break-all;}  /* table不超過div */
</style>
